import React from "react";
import skills from "../assets/images/icons/Eligibility.svg";
import placement from "../assets/images/icons/placement.svg";
import info from "../assets/images/icons/AboutProg.svg";
import wage from "../assets/images/icons/Earn_Learn.svg";
import accounting from "../assets/images/icons/Fees.svg";
import jigsaw from "../assets/images/icons/Selection.svg";
import university from "../assets/images/icons/Academy.svg";
import controls from "../assets/images/icons/skills.webp";
import Qualification from "../assets/images/icons/Qualification.svg";
import age from "../assets/images/icons/Age.jpg";
import education from "../assets/images/icons/education.jpg";
import role from "../assets/images/icons/location.jpg";
import experience from "../assets/images/icons/Experience.jpg";
import qualifingmarks from "../assets/images/icons/Qualifying marks.jpg";
const KnowMoreElligibiltyComponent = () => {
  return (
    <>
      <section className="knowmore py-md-5 pb-2 ">
        <div className="container">
          <h2>Click below to know more</h2>
          <div className="owl-carousel owl-theme" id="knowmore">
            <div className="item">
              <div className="box text-center">
                <a
                  href="#scrollEligibility"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={skills}
                      width="40px"
                      height="40px"
                      alt="The Eligibility"
                      className="img-fluid"
                    />
                  </div>
                  <p>Eligibility</p>
                </a>
              </div>
            </div>
            <div className="item">
              <div className="box text-center">
                <a
                  href="#scrolljobplace"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={placement}
                      width="40px"
                      height="40px"
                      alt="The Placement and Salary"
                      className="img-fluid"
                    />
                  </div>
                  <p>Placement and salary</p>
                </a>
              </div>
            </div>
            <div className="item">
              <div className="box text-center">
                <a
                  href="#scrollAboutProg"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={info}
                      width="40px"
                      height="40px"
                      alt="The About the Programme"
                      className="img-fluid"
                    />
                  </div>
                  <p>About the programme</p>
                </a>
              </div>
            </div>
            {/* <div className="item">
                    <div className="box text-center">
                        <a href="#scrollearnwhile" className="d-flex align-items-center flex-column">
                        <div className="imgwrap">
                            <img src={wage} width="40px" height="40px" alt="The Earn while you learn" className="img-fluid"/>
                            </div>
                            <p>Earn while you learn</p>
                        </a>
                    </div>
                </div> */}
            {/* <div className="item">
              <div className="box text-center">
                <a
                  href="#scrollprogfess"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={accounting}
                      width="40px"
                      height="40px"
                      alt="The Programme Fees"
                      className="img-fluid"
                    />
                  </div>
                  <p>Programme fees</p>
                </a>
              </div>
            </div> */}
            <div className="item">
              <div className="box text-center">
                <a
                  href="#scrollselprocess"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={jigsaw}
                      width="40px"
                      height="40px"
                      alt="The Selection Process"
                      className="img-fluid"
                    />
                  </div>
                  <p>Selection process</p>
                </a>
              </div>
            </div>
            {/* <div className="item">
              <div className="box text-center">
                <a
                  href="#scrollaboutmani"
                  className="d-flex align-items-center flex-column"
                >
                  <div className="imgwrap">
                    <img
                      src={university}
                      width="40px"
                      height="40px"
                      alt="The About Manipal Academy"
                      className="img-fluid"
                    />
                  </div>
                  <p>About Manipal Academy</p>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section className="eligibility" id="scrollEligibility">
        <div className="container">
          <h2 className="title">Eligibility</h2>
          {/* <div className="row justify-content-evenly my-md-5 my-4"> */}
          <div className="row my-md-5 my-4">
            <div className="col-md-5 mb-4 mb-md-0">
              <div className="box">
                <div>
                  <img
                    src={age}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                </div>
                <div className="m-left m-top">
                  <p className="title">Age</p>
                  <p className="desc">Age should be 25 years or below.</p>
                </div>
              </div>
            </div>
            <div className="col-md-5 mb-4 mb-md-0">
              <div className="box">
                <div className="">
                  <img
                    src={qualifingmarks}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                </div>
                <div className="m-left">
                  <p className="title">Qualifying Marks</p>
                  <p className="desc">
                    Minimum with 60% in 10th and Graduation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-5 mb-4 mb-md-0">
              <div className="box">
                <div>
                  <img
                    src={education}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                </div>
                <div className="m-left m-top">
                  <p className="title">Education</p>
                  <p className="desc">
                    Graduates, Engineers, Post-Graduate/MBA pass-outs are
                    eligible to apply.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-5 mb-4 mb-md-0">
              <div className="box">
                <div>
                  <img
                    src={role}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                </div>
                <div className="m-left m-top">
                  <p className="title">Role and Location Fungibility</p>
                  <p className="desc">
                    Applicant should be locationally mobile and willing to do
                    sales.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-5 mb-4 mb-md-0">
              <div className="box">
                <div>
                  <img
                    src={experience}
                    alt="Age"
                    className="eligiImg"
                    width="50px"
                    height="50px"
                  />
                </div>
                <div className="m-left m-top">
                  <p className="title">Experience</p>
                  <p className="desc"> 0 to 2 years.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KnowMoreElligibiltyComponent;
